import React from 'react';
import {useEnvironment} from '@wix/yoshi-flow-editor';
import {pageTheme} from '../../../common/components/WithThemeOverride/pageTheme';

export enum PoliciesPageDataHook {
  root = 'PoliciesPageDataHook.root',
}

const PoliciesPage = () => {
  const {isMobile} = useEnvironment();

  return (
    <div style={pageTheme} className={isMobile ? 'mobile-view' : undefined} data-hook={PoliciesPageDataHook.root}></div>
  );
};

// eslint-disable-next-line import/no-default-export
export default PoliciesPage;
